import $store from '@/store.js'
import Tool from '@/assets/js/utils.js'
import Bus from '@/assets/js/vueBus.js'
// 初始化Billing
function initBilling (callBack) {
  const params = {
    url: $store.state.common.baseUrl.billingService,
    session: Tool.getSession(),
    hotjarCode: '2659750',
    product: 'Tvuchannel'
  }

  window.BillingObject = new BillingIframe(params, () => {
    queryBillingStatus()
    callBack && callBack(true)
  })

  // window.BillingObject = BillingObject
  // 有BillingObj之后就可以开始查询Billing状态
}
// check当前账号的Billing状态
async function queryBillingStatus () {
  const params = {
    customerId: $store.state.common.baseUserInfo.email,
    product: 'Tvuchannel'
  }
  let status = false
  await BillingObject.querySubStatus(params).then((res) => {
    status = res
    $store.state.common.billingStatus = status
  })
  return status
}
// 创建Channel时
async function checkCreateChannel (callBack) {
  const params = {
    customerId: $store.state.common.baseUserInfo.email,
    product: 'Tvuchannel',
    chargeItems: JSON.stringify([{ id: 'tvuchannel-channels', increase: 1 }])
  }
  await BillingObject.checkCreate(params).then((res) => {
    callBack && callBack(res)
  }).catch((err) => {
    callBack && callBack(err)
  })
}
// 获取Billing状态
async function getBillingStatus (realRefresh) {
  const billingStatus = true
  const subscribeObj = null
  const params = {
    customerId: $store.state.common.baseUserInfo.email,
    product: 'Tvuchannel'
  }
  const obj = await BillingObject.getStatus(params)
  setBillingInfo(obj)
  BillingObject.intervalParams.open = false
  if (realRefresh) {
    // 实时获取Billing信息
    BillingObject.intervalQueryParams = params
    BillingObject.intervalParams.open = true
    BillingObject.intervalParams.duration = 10000
    BillingObject.onSubStatus = (freshObj) => {
      setBillingInfo(freshObj)
    }
  }
  return obj
}
function setBillingInfo (obj) {
  if (obj.permission && obj.permission.code == '0x0') {
    $store.state.common.billingStatus = true
  } else {
    $store.state.common.billingStatus = false
    $store.state.common.subscribeObj = obj.permission.redirect
  }
  if (window.mediaObj) {
    mediaObj.billingStatus = $store.state.common.billingStatus
  }
}
// 处理Billing相关信息
function handleBillingInfo (subscribeObj) {
  const iframeData = subscribeObj || null
  BillingObject.handleOpenBill({
    open: () => iframeData,
    step: (step) => {
      // 谷歌统计
      if (step && step.type == 'Event-Google-Analytics') {
        try {
          gtag('event', `Channel-${step.key}`)
        } catch (err) {
          console.log('The Google analysis has not been loaded yet')
        }
      }
      // session过期，需要跳转到登录页
      if (step && step.type == 'Session Expired') {
        Bus.$emit('jumpLoginPage')
      }
    },
    close: async () => {
      // 关闭的时候还需要再去拿一次BillingStatus
      const obj = await queryBillingStatus()
    }
  })
}

function queryBilling (type, callBack) {
  const params = {
    type, // createChannel | manage 区分是那种方式
    queryParams: {
      customerId: $store.state.common.baseUserInfo.email,
      product: 'Tvuchannel',
      chargeItems: JSON.stringify([{ id: 'tvuchannel-channels', increase: 1 }])
    }
  }
  // 第二个参数就是之前的 handleOpenBill 接口的回调对象
  BillingObject.handlePermission(params, {
    open: () => {},
    step: (step) => {
      // 谷歌统计
      if (step && step.type == 'Event-Google-Analytics') {
        try {
          gtag('event', `Channel-${step.key}`)
        } catch (err) {
          console.log('The Google analysis has not been loaded yet')
        }
      }
      // session过期，需要跳转到登录页
      if (step && step.type == 'Session Expired') {
        Bus.$emit('jumpLoginPage')
      }
    },
    close: async () => {
      // 关闭的时候还需要再去拿一次BillingStatus
      const obj = await queryBillingStatus()
    },
    createChannel: () => {
      callBack && callBack()
      // 可以创建
    }
  })
}

export {
  handleBillingInfo,
  initBilling,
  getBillingStatus,
  queryBillingStatus,
  checkCreateChannel,
  queryBilling
}
